/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGroupSessionModel } from '../../models/create-group-session-model';
import { GroupSessionModel } from '../../models/group-session-model';

export interface CreateGroupSession$Params {
      body?: CreateGroupSessionModel
}

export function CreateGroupSession(http: HttpClient, rootUrl: string, params?: CreateGroupSession$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupSessionModel>> {
  const rb = new RequestBuilder(rootUrl, CreateGroupSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupSessionModel>;
    })
  );
}

CreateGroupSession.PATH = '/api/Staff/CreateGroupSession';
